export default __webpack_public_path__ + "static/media/Arrow-left-white.fdcd2c88.svg";